<template>
<div class="navbar">
    <el-menu mode="vertical"
    text-color=""
    :unique-opened="true"
    class="el-menu-vertical-demo"
    :default-active="defaultRouter" :collapse="isCollapse">
        <template v-for="item in routes">
            <el-submenu :index="item.menuName" :key="item.menuName" v-if="item.children">
                <template slot="title">
                    <i :class="menuIcon[item.menuLink]"></i>
                    <span>{{item.menuName}}</span>
                </template>
                <template v-for="child in item.children">
                    <router-link :key="child.menuName" :to=" child.menuLink">
                        <el-menu-item :index="child.menuLink">
                            {{child.menuName}}
                        </el-menu-item>
                    </router-link>
                </template>
            </el-submenu>
            <router-link :key="item.menuName" :to="item.menuLink" v-else>
                <el-menu-item :index="item.menuLink">
                    <i :class="menuIcon[item.menuLink]"></i>
                    <span slot="title">首页</span>
                </el-menu-item>
            </router-link>
        </template>
    </el-menu>
    <div class="toggle-bar" @click="toggle">
        <i class="el-icon-d-arrow-right" v-if="isCollapse"></i>
        <i class="el-icon-d-arrow-left" v-else></i>
    </div>
</div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex';
import {menuIcon} from '@/modules/config/zft';
export default {
    created() {
        this.init();
    },
    data() {
        return {
            menuIcon,
            routes: [],
            isCollapse: false
        };
    },
    computed: {
        defaultRouter() {
            return this.$route.path;
        },
        ...mapGetters('zft', ['menuList'])
    },
    methods: {
        init(){
            this.routes = this.menuList;
        },
        toggle() {
            this.isCollapse = !this.isCollapse;
            this.$store.commit('CHANGE_NAVBAR_STATUS', !this.isCollapse);
        },
    }
};
</script>
<style lang="stylus" scoped>
.navbar
    height 100%
    position fixed
    left 0
.el-menu
    min-height 100%;

.el-menu-vertical-demo:not(.el-menu--collapse)
    width 200px
.toggle-bar
    position absolute
    right 10px
    margin-top -80px
    z-index 99
    cursor pointer
    color #587097
a
    text-decoration none
/deep/.router-link-active,.router-link-exact-active
    li
        background #8AB044
        color #fff


</style>
